import { INotificationFillLevelSettingsDto } from 'api/api';
import React from 'react';
import BiCalendar from 'view/shared/components/bi-calendar/bi-calendar';

export interface Props {
	fillLevelSetting: INotificationFillLevelSettingsDto;
	value?: Date;
	onChange: (e: any, fillLevelSetting: INotificationFillLevelSettingsDto) => void;
}

export const FillLevelTimePicker: React.FC<Props> = React.memo(({ value, onChange, fillLevelSetting }) => {
	const handleTimeChange = (e: { value: Date }) => {
		onChange(e, fillLevelSetting);
	};

	return <BiCalendar onChange={handleTimeChange} value={value} timeOnly />;
});
